
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-all-directory',
  templateUrl: './all-directory.component.html'
})
export class AllDirectoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}